export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";